import { Component, OnInit} from '@angular/core';
import {FacilityService,TicketsService} from 'src/app/services/'
import {CreateTicketFormFields,SaveBatchTicket, SelectedBatchEquipment} from 'src/app/models/tickets/createTicketFormFields'


@Component({
  selector: 'bart-covid-attestation',
  templateUrl: './covid-attestation.component.html',
  styleUrls: ['./covid-attestation.component.scss']
})
export class CovidAttestationComponent implements OnInit {
  public formFields:CreateTicketFormFields;
  public disabled:boolean=false;
  public errorClass:string="";
  public btnactive="Next";
  public objBatchTicket:SaveBatchTicket;
  public objcovidAttestation:CovidAttestation[];
  public errorHeader:string="";
  public errorContent:string="";
  public displayError:boolean=false;

  constructor(private _ticketService:TicketsService) {
    this.formFields=new CreateTicketFormFields();
   }

   ngOnInit() {
    
      this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
      this.formFields=Result;
      this.objcovidAttestation=this.formFields.selectedBatchEquipmentList;
     }, 
     (error) => {
       console.log(error);
     }
   );
   
  }
 
  public btnBackClicked()
  {
   
    for(let obj of this.objcovidAttestation)
      {
       
           obj.selectedValueA=null
           obj.selectedValueB=null
           obj.selectedValueC=null
          
      }
    this.formFields.showCurrentTemplate=false;
    
  }
  public btnNextClicked()
  {
   
    var saveOk = this.savecovidValues(true);
    if(saveOk)
    {
     if(this.objcovidAttestation.length>0)
     {
       this.btnactive="Modify";
       this.formFields.isShowBatchLabour=true;
       this.disabled=true;
     }
     else
     {
       this.btnBackClicked();
     }
    }
    else
    {
     this.btnactive="Next";
     this.formFields.isShowBatchLabour=false;
     this.disabled=false;
     
    }
  }
  public btnModifyClicked()
  {
   this.btnactive="Next";
   this.formFields.isShowBatchLabour=false;
   this.disabled=false;
  }
  public hideErrorDialog()
  {
   this.displayError=false;
  }
  public savecovidValues(showAlert)
 {
   
   
    let success:boolean=true;
    let errors:covidAttestationErrors[]=[];
    this.formFields.batchTicketObj=[]
    for(let obj of this.objcovidAttestation)
    {
       let equipmentId=obj.EquipmentID;
       let serialNumber =obj.EquipmentSerialNumber;
       let ret =this.checkcovidAttestation(obj);
       if(ret.covidAttestationAOk==false || ret.covidAttestationBOk==false || ret.covidAttestationCOk==false) 
       {
         errors.push(ret);
       }
    }
    if(errors.length==0)
    {
    
      for(let obj of this.objcovidAttestation)
      {
          this.objBatchTicket=new SaveBatchTicket();
          this.objBatchTicket.equipmentId=obj.EquipmentID
          this.objBatchTicket.covidAttestationA = obj.selectedValueA
          this.objBatchTicket.covidAttestationB = obj.selectedValueB
          this.objBatchTicket.covidAttestationC = obj.selectedValueC
          this.formFields.batchTicketObj.push(this.objBatchTicket);
      }
    }
    else
    {
      
      success=false;
      this.formFields.batchTicketObj=null;
      this.errorClass="batchError"
      var errorMsg = '';
      var i = 0;
       for(let x of errors)
       {
        errorMsg += "<div class='errorHeader'>"+x.mainErrorMessage +"</div>";
        for (i=0;i<x.errorMsg.length;i++) 
        {
          errorMsg += x.errorMsg[i] + '<br/>';
        }
       }
       if(showAlert)
       {
         //alert (errorMsg);
         this.errorHeader="Validation Error";
         this.errorContent=errorMsg;
         this.displayError=true;
       }
    }
    return success
 }
 public checkcovidAttestation(obj:CovidAttestation)
 { 
   
    let ret:covidAttestationErrors = 
    {
      covidAttestationAOk:false,
	  	covidAttestationBOk:false,
	  	covidAttestationCOk:false,
      mainErrorMessage:"",
      errorMsg:[]
    }
 

	if ( obj.selectedValueA==null ||  obj.selectedValueA==undefined) {
		ret.errorMsg.push('You must answer I attest that I do not have a temperature over 100.0 F at this time.\n');
    ret.covidAttestationAOk = false;
    //obj.errorClass="batchError"
	} else {
	
		ret.covidAttestationAOk = true;
	}
	
	if  ( obj.selectedValueB==null ||  obj.selectedValueB==undefined) {
		ret.errorMsg.push('You must answer I attest that I am not experiencing any coughing or shortness of breath.\n');
    ret.covidAttestationBOk = false;
    //obj.errorClass="batchError"
	} else {

		ret.covidAttestationBOk = true;
	}

	if ( obj.selectedValueC==null ||  obj.selectedValueC==undefined) {
		ret.errorMsg.push('You must answer I attest that I understand that I should not report to work if I am experiencing a temperature greater than or equal to 100.0 F, coughing and / or shortness of breath, and that if I do, I must notify my manager immediately prior to reporting to work.\n');
    ret.covidAttestationCOk = false;
    obj.errorClass="batchError"
	} else {

    ret.covidAttestationCOk = true;
    obj.errorClass="";
	}	

    return ret;
}
}
export  class  CovidAttestation extends  SelectedBatchEquipment{
  //extra Fields
  
  selectedValueA:Boolean;
  selectedValueB:Boolean;
  selectedValueC:Boolean;
  errorClass:string="";
  }
export class covidAttestationErrors
{
  covidAttestationAOk:boolean
  covidAttestationBOk:boolean
  covidAttestationCOk:boolean

  mainErrorMessage:string;
  errorMsg:string[]=[];
}
